import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { OrganisationDetail, PlatformFeature } from 'api'
import { DataGrid, filteredColumnDefsBuilder, GridId } from 'view/components/datagrid'
import { organisationDetailsSelector } from 'selectors/organisationSelectors'
import { OrganisationColumnDefs, OrganisationGridColumnId, organisationGridOptions } from './OrganisationGridModel'
import { createPlatformFeatureEnabledSelector } from 'selectors/platformSelectors'

interface OrganisationGridProps {
  organisationList: OrganisationDetail[]
  platformStartConsiderationOverrideEnabled: boolean
}

const mapStateToProps = createStructuredSelector({
  organisationList: organisationDetailsSelector,
  platformStartConsiderationOverrideEnabled: createPlatformFeatureEnabledSelector(PlatformFeature.ENABLE_START_CONSIDERATION_OVERRIDE)
})

export const OrganisationGridComponent: React.FunctionComponent<OrganisationGridProps> = ({
  organisationList,
  platformStartConsiderationOverrideEnabled
}) => {
  const filteredColumnDefs = useMemo(
    () =>
      filteredColumnDefsBuilder(OrganisationColumnDefs)
        .withoutIf(!platformStartConsiderationOverrideEnabled, [OrganisationGridColumnId.ORGANISATION_START_CONSIDERATION_OVERRIDE_ENABLED])
        .build(),
    [platformStartConsiderationOverrideEnabled]
  )

  return (
    <DataGrid
      gridId={GridId.AdminOrganisationGrid}
      gridOptions={organisationGridOptions}
      rowData={organisationList}
      columnDefs={filteredColumnDefs}
    />
  )
}

export const OrganisationGrid = connect(mapStateToProps)(OrganisationGridComponent)
